import "./TituloTabela.css";
export const SubTituloTabela = (props) => {
  return (
    <div className="SubTituloTabelaa">
      <strong className="strong" {...props} />
      <p> </p>
    </div>
  );
};
